import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Field } from "@/components/common";

function Pick({ label, value, onChange, options, testId, all }) {
  return (
    <Field label={label}>
      <Select value={value || "all"} onValueChange={(v) => onChange(v === "all" ? "" : v)}>
        <SelectTrigger className="min-w-[160px]" data-testid={testId}><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value="all">{all}</SelectItem>
          {options.map((o) => <SelectItem key={o.id} value={o.id}>{o.name}</SelectItem>)}
        </SelectContent>
      </Select>
    </Field>
  );
}

export function ReportFilters({ f, setF, opts }) {
  const set = (k) => (v) => setF((x) => ({ ...x, [k]: v }));
  return (
    <div className="card-surface p-4 flex flex-wrap items-end gap-3" data-testid="report-filters">
      <Field label="De"><Input type="date" value={f.start} onChange={(e) => set("start")(e.target.value)} data-testid="report-start-input" /></Field>
      <Field label="Até"><Input type="date" value={f.end} onChange={(e) => set("end")(e.target.value)} data-testid="report-end-input" /></Field>
      <Pick label="Usuário" value={f.user_id} onChange={set("user_id")} options={opts.users} all="Todos os usuários" testId="report-user-select" />
      <Pick label="Unidade" value={f.store_id} onChange={set("store_id")} options={opts.stores} all="Todas as unidades" testId="report-store-select" />
      <Pick label="Forma de pagamento" value={f.payment_method} onChange={set("payment_method")} options={opts.methods} all="Todas as formas" testId="report-method-select" />
    </div>
  );
}
